/* The Mint Workshop — scroll-reactive marquee.
   Always drifting; flips direction with the scroll direction and picks up
   speed with scroll velocity. Runs on transform only. Fails open: without JS
   the strip is simply static. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var lastY = window.pageYOffset;
  var dir = 1;
  var boost = 0;

  window.addEventListener('scroll', function () {
    var y = window.pageYOffset;
    var d = y - lastY;
    if (Math.abs(d) > 0.5) dir = d > 0 ? 1 : -1;
    // velocity feeds the drift, capped so a flick does not send it flying
    boost = Math.min(Math.abs(d) * 0.55, 26);
    lastY = y;
  }, { passive: true });

  function attach(strip) {
    if (strip.dataset.mwMarqOn === '1') return;   // never bind twice
    var track = strip.querySelector('.mw-marq__track');
    if (!track) return;
    strip.dataset.mwMarqOn = '1';

    var base = parseFloat(strip.dataset.speed || '0.5');
    var flip = strip.dataset.reverse === 'true' ? -1 : 1;
    var offset = 0;
    var half = 0;

    function measure() {
      // the track holds the sequence twice; one copy is the wrap distance
      half = track.scrollWidth / 2;
      if (!half) half = 1;
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    (function tick() {
      offset -= (base + boost) * dir * flip;
      if (offset <= -half) offset += half;
      else if (offset > 0) offset -= half;
      track.style.transform = 'translate3d(' + offset.toFixed(2) + 'px,0,0)';
      requestAnimationFrame(tick);
    })();
  }

  function scan() {
    [].slice.call(document.querySelectorAll('[data-mw-marquee]')).forEach(attach);
  }

  /* Strips can arrive after this script runs — the header is re-rendered in the
     theme editor, and injected client-side in the prototype. Scanning on
     mutation means a late strip still animates. */
  scan();
  if ('MutationObserver' in window) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', scan);

  // decay the boost independently, so it eases out after the scroll stops
  (function decay() {
    boost *= 0.93;
    if (boost < 0.01) boost = 0;
    requestAnimationFrame(decay);
  })();
})();
